import request from '../../util/SuperagentUtils';

export const requestCreateServiceCharge = (bookingId, serviceFeeCharge) => {
  return request.post(`/api/booking/${bookingId}/service-charge`)
    .send(serviceFeeCharge);
}

export const requestCalculateServiceChargeTax = (bookingId, serviceFeeCharge) => {
  return request.post(`/api/booking/${bookingId}/service-charge/calculate-tax`)
    .send(serviceFeeCharge);
}

export const requestBookingTransactionById = (bookingTransactionId) => {
  return request.get(`/api/booking-transaction/${bookingTransactionId}`);
}
